webpackJsonp([1],{

/***/ 141:
/*!******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FontChooser.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sample_vue__ = __webpack_require__(/*! ./Sample.vue */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_FontExamples__ = __webpack_require__(/*! ../utils/FontExamples */ 327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_FontExamples___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_FontExamples__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Sample: __WEBPACK_IMPORTED_MODULE_0__Sample_vue__["a" /* default */]
  },
  data: function data() {
    return {
      width: 20,
      visible: true,
      letters: "ABCDEFG".split("")
    };
  },

  props: {
    modelData: { type: String, default: "A" },
    selectedSample: {},
    model: {},
    samples: { type: Array, default: function _default() {
        return [__WEBPACK_IMPORTED_MODULE_1__utils_FontExamples__["zero"], __WEBPACK_IMPORTED_MODULE_1__utils_FontExamples__["crispSerif"], __WEBPACK_IMPORTED_MODULE_1__utils_FontExamples__["serifItalic"], __WEBPACK_IMPORTED_MODULE_1__utils_FontExamples__["serifBlackItalic"], __WEBPACK_IMPORTED_MODULE_1__utils_FontExamples__["sansLight"], __WEBPACK_IMPORTED_MODULE_1__utils_FontExamples__["casual"], __WEBPACK_IMPORTED_MODULE_1__utils_FontExamples__["dotMatrix"]];
      } }
  },
  watch: {
    model: function model(val) {
      this.select(this.samples[0], true);
    }
  },
  methods: {
    deleteSample: function deleteSample(index) {
      this.samples.splice(index, 1);
    },
    select: function select(sample, isInitialSelection) {
      this.$emit("select", { selectedSample: sample, isInitialSelection: isInitialSelection });
    },
    save: function save() {
      this.samples.push(this.selectedSample);
    }
  }
});

/***/ }),

/***/ 142:
/*!***************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Alphabet.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sample_vue__ = __webpack_require__(/*! ./Sample.vue */ 37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Sample: __WEBPACK_IMPORTED_MODULE_0__Sample_vue__["a" /* default */]
  },
  data: function data() {
    return {
      width: 48,
      visible: true,
      sections: ["ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("")]
    };
  },

  props: {
    modelData: { type: String, default: "A" },
    model: {},
    sample: { default: function _default() {
        [];
      } }
  }
});

/***/ }),

/***/ 143:
/*!***************!*\
  !*** multi . ***!
  \***************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /usr/local/google/home/jwexler/pair-code/font-explorer */144);


/***/ }),

/***/ 144:
/*!******************!*\
  !*** ./index.ts ***!
  \******************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __webpack_require__(/*! vue */ 66);
var App_vue_1 = __webpack_require__(/*! ./App.vue */ 148);
new vue_1.default({ el: '#app', render: function (h) { return h(App_vue_1.default); } });


/***/ }),

/***/ 148:
/*!*****************!*\
  !*** ./App.vue ***!
  \*****************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 67);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_545c3eb6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !./node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-545c3eb6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 335);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-545c3eb6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 149)
}
var normalizeComponent = __webpack_require__(/*! ./node_modules/vue-loader/lib/component-normalizer */ 12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-545c3eb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_545c3eb6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 149:
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-545c3eb6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 150:
/*!*******************************!*\
  !*** ./components/footer.vue ***!
  \*******************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./footer.vue */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd7659f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-fd7659f6","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./footer.vue */ 152);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-fd7659f6","scoped":false,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./footer.vue */ 151)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd7659f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 151:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fd7659f6","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/footer.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 152:
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd7659f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/footer.vue ***!
  \********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"mdl-mini-footer"},[_c('div',{staticClass:"mdl-mini-footer__left-section"},[_c('div',{staticClass:"mdl-logo"},[_c('a',{attrs:{"href":"https://www.google.com","target":"_blank"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 68 28","width":"68","height":"28"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h68v28H0z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#9E9E9E","d":"M8.34 18.32c-4.52 0-8.32-3.68-8.32-8.2s3.8-8.2 8.32-8.2c2.5 0 4.28.98 5.62 2.26l-1.58 1.58c-.96-.9-2.26-1.6-4.04-1.6-3.3 0-5.88 2.66-5.88 5.96s2.58 5.96 5.88 5.96c2.14 0 3.36-.86 4.14-1.64.64-.64 1.06-1.56 1.22-2.82H8.34V9.38h7.54c.08.4.12.88.12 1.4 0 1.68-.46 3.76-1.94 5.24-1.44 1.5-3.28 2.3-5.72 2.3zm19.46-5.28c0 3.04-2.38 5.28-5.3 5.28s-5.3-2.24-5.3-5.28c0-3.06 2.38-5.28 5.3-5.28s5.3 2.22 5.3 5.28zm-2.32 0c0-1.9-1.38-3.2-2.98-3.2s-2.98 1.3-2.98 3.2c0 1.88 1.38 3.2 2.98 3.2s2.98-1.32 2.98-3.2zm14.32 0c0 3.04-2.38 5.28-5.3 5.28s-5.3-2.24-5.3-5.28c0-3.06 2.38-5.28 5.3-5.28s5.3 2.22 5.3 5.28zm-2.32 0c0-1.9-1.38-3.2-2.98-3.2s-2.98 1.3-2.98 3.2c0 1.88 1.38 3.2 2.98 3.2s2.98-1.32 2.98-3.2zm13.84-4.96v9.48c0 3.9-2.3 5.5-5.02 5.5-2.56 0-4.1-1.72-4.68-3.12l2.02-.84c.36.86 1.24 1.88 2.66 1.88 1.74 0 2.82-1.08 2.82-3.1v-.76h-.08c-.52.64-1.52 1.2-2.78 1.2-2.64 0-5.06-2.3-5.06-5.26 0-2.98 2.42-5.3 5.06-5.3 1.26 0 2.26.56 2.78 1.18h.08v-.86h2.2zm-2.04 4.98c0-1.86-1.24-3.22-2.82-3.22-1.6 0-2.94 1.36-2.94 3.22 0 1.84 1.34 3.18 2.94 3.18 1.58 0 2.82-1.34 2.82-3.18zm6.41-10.58V18h-2.32V2.48h2.32zm9.41 12.3l1.8 1.2c-.58.86-1.98 2.34-4.4 2.34-3 0-5.24-2.32-5.24-5.28 0-3.14 2.26-5.28 4.98-5.28 2.74 0 4.08 2.18 4.52 3.36l.24.6-7.06 2.92c.54 1.06 1.38 1.6 2.56 1.6 1.18 0 2-.58 2.6-1.46zm-5.54-1.9l4.72-1.96c-.26-.66-1.04-1.12-1.96-1.12-1.18 0-2.82 1.04-2.76 3.08z"}})])])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"mdl-mini-footer__link-list"},[_c('li',[_c('a',{attrs:{"href":"https://www.google.ai/pair","target":"_blank"}},[_vm._v("People + AI Research Initiative")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-mini-footer__right-section"},[_c('ul',{staticClass:"mdl-mini-footer__link-list"},[_c('li',[_c('a',{attrs:{"href":"https://pair-code.github.io","target":"_blank"}},[_vm._v("PAIR Open Source")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://github.com/PAIR-code","target":"_blank"}},[_vm._v("Source on Github")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 153:
/*!*******************************!*\
  !*** ./components/header.vue ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_845dca98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-845dca98","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./header.vue */ 155);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-845dca98","scoped":false,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./header.vue */ 154)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 12)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_845dca98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 154:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-845dca98","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/header.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 155:
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-845dca98","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/header.vue ***!
  \********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"mdl-layout__header mdl-layout--fixed-header is-casting-shadow"},[_c('link',{attrs:{"rel":"stylesheet","href":"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700","type":"text/css"}}),_vm._v(" "),_c('link',{attrs:{"rel":"stylesheet","href":"https://fonts.googleapis.com/icon?family=Material+Icons"}}),_vm._v(" "),_c('link',{attrs:{"rel":"stylesheet","href":"https://code.getmdl.io/1.3.0/material.orange-deep_purple.min.css"}}),_vm._v(" "),_c('div',{staticClass:"mdl-layout__header-row"},[_c('a',{staticClass:"main-title",attrs:{"href":"https://deeplearnjs.org"}},[_c('span',{staticClass:"mdl-layout-title"},[_vm._v("deeplearn.js")])]),_vm._v("  "),_c('span',[_vm._v("Latent Space Explorer")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 156:
/*!****************************************!*\
  !*** ./components/BasisDimensions.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BasisDimensions_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./BasisDimensions.vue */ 69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cf987f0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasisDimensions_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7cf987f0","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./BasisDimensions.vue */ 324);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7cf987f0","scoped":true,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./BasisDimensions.vue */ 157)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cf987f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BasisDimensions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cf987f0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasisDimensions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 157:
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cf987f0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/BasisDimensions.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 158:
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a91f88f","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Sample.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 159:
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a91f88f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Sample.vue ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({width: _vm.displayWidth + 'px', height: _vm.displayHeight + 'px'})},[_c('canvas',{ref:"canvas",class:{ waiting: _vm.waiting || _vm.dirty, ready: !_vm.waiting && !_vm.dirty },attrs:{"width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 160:
/*!*****************************!*\
  !*** ./components/Tray.vue ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Tray_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Tray.vue */ 71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec9a7f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tray_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5ec9a7f6","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Tray.vue */ 323);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5ec9a7f6","scoped":true,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Tray.vue */ 161)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ec9a7f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Tray_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec9a7f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tray_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 161:
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ec9a7f6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Tray.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 162:
/*!******************************!*\
  !*** ./components/XAxis.vue ***!
  \******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_XAxis_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./XAxis.vue */ 72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16b4a391_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_XAxis_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-16b4a391","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./XAxis.vue */ 240);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-16b4a391","scoped":true,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./XAxis.vue */ 163)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16b4a391"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_XAxis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16b4a391_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_XAxis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 163:
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16b4a391","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/XAxis.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 240:
/*!******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b4a391","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/XAxis.vue ***!
  \******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"domain"},_vm._l((_vm.ticks),function(tick){return _c('div',{staticClass:"tick",style:({left: tick.position + 'px'})},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(tick.value))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 250:
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 323:
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ec9a7f6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Tray.vue ***!
  \*****************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"container",on:{"mousedown":_vm.dragStart}},[_c('div',{staticClass:"tray",style:({height: _vm.height + 'px'})},[_vm._l((_vm.samples),function(sample,index){return _c('Sample',{key:index,style:({position: 'absolute', left: sample.position + 'px'}),attrs:{"visible":_vm.visible,"displayWidth":_vm.sampleWidth,"displayHeight":_vm.sampleWidth,"model":_vm.model,"character":_vm.modelData,"sample":sample.sample}})}),_vm._v(" "),_c('div',{staticClass:"reticle selected",style:({left: _vm.selectedX + 'px', height: _vm.height + 6 + 'px'})},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.format(_vm.selectedValue)))])])],2),_vm._v(" "),_c('Axis',{attrs:{"min":_vm.extent[0],"max":_vm.extent[1],"width":_vm.width}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 324:
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cf987f0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/BasisDimensions.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.basisDimensions),function(basis,i){return _c('div',{ref:"root",refInFor:true,staticClass:"root"},[_c('h4',{staticClass:"label"},[_c('span',[_vm._v(_vm._s(i + 1))])]),_vm._v(" "),_c('Tray',{attrs:{"scrollY":_vm.scrollY,"model":_vm.model,"modelData":_vm.modelData,"direction":basis,"range":_vm.range,"numSamples":_vm.numSamples,"selectedSample":_vm.selectedSample,"initialValue":_vm.vals[i],"width":_vm.width - 50},on:{"select":_vm.select}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 325:
/*!************************************!*\
  !*** ./components/FontChooser.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FontChooser_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./FontChooser.vue */ 141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27b6baf7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FontChooser_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-27b6baf7","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./FontChooser.vue */ 328);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-27b6baf7","scoped":true,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./FontChooser.vue */ 326)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27b6baf7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FontChooser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27b6baf7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FontChooser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 326:
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27b6baf7","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/FontChooser.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 327:
/*!*******************************!*\
  !*** ./utils/FontExamples.ts ***!
  \*******************************/
/*! dynamic exports provided */
/*! exports used: casual, crispSerif, dotMatrix, sansLight, serifBlackItalic, serifItalic, zero */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dl = __webpack_require__(/*! deeplearn */ 32);
function convert(arr) {
    return dl.tensor1d(arr);
}
exports.zero = convert([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
]);
exports.serif = convert([
    0.0371049, -0.00813934, -0.0238383, -0.0089827, -0.177821, -0.0574084,
    0.0770413, -0.000690518, 0.0769115, 0.0351161, 0.0814512, -0.051607,
    -0.0107203, 0.0349532, -0.0383251, 0.181566, 0.0180368, -0.0190421,
    0.00265053, 0.0662852, -0.00912406, -0.0311079, 0.0265557, -0.0487921,
    0.0534228, -0.00273521, -0.0197219, -0.0644585, -0.0577662, 0.0156284,
    0.0991329, -0.0128064, -0.143012, 0.105797, -0.0986753, -0.0196918,
    0.0378637, 0.0833659, -0.095302, 0.0795064
]);
exports.serifLight = convert([
    -0.0216557, -0.00510807, 0.069025, 0.0710787, -0.121001, -0.00133361,
    0.0611789, 0.00982594, 0.0879688, 0.0295542, -0.0122143, -0.063498,
    -0.00521591, -0.0601163, -0.0713968, 0.0671673, -0.0106555, -0.0593602,
    0.011764, 0.010934, -0.0169469, -0.0534629, -0.0388112, -0.0123401,
    0.0939846, 0.0165921, 0.129371, -0.00280703, -0.0500156, 0.0379629,
    -0.0618881, -0.0376599, -0.0311708, 0.00728275, 0.017297, -0.0299181,
    0.0465943, 0.0237103, -0.0745177, 0.0343391
]);
exports.serifLightItalic = convert([
    -0.0506065, 0.00701319, 0.0615123, 0.0393102, -0.0948454, -0.0137425,
    0.111544, 0.0391769, 0.0859902, 0.0170246, 0.0201402, -0.136518,
    -0.0167641, -0.0607857, -0.0744675, 0.0540874, -0.00200216, -0.0665509,
    0.00257809, 0.00233295, 0.0140137, -0.0801842, -0.0423244, 0.0355004,
    0.0580647, -0.0138478, 0.0933243, 0.0184801, -0.0190279, 0.0137804,
    -0.051851, -0.0562538, -0.0308516, 0.0050458, 0.0519893, -0.0359038,
    0.0213445, 0.0160722, -0.0385736, -0.0141683
]);
exports.serifItalic = convert([
    -0.00709412, -0.00226927, -0.0460972, -0.0311495, -0.184267, -0.0840899,
    0.105059, 0.0399571, 0.0399989, 0.015467, 0.109084, -0.112228,
    -0.0298777, 0.0207973, -0.0211743, 0.196855, 0.00719617, -0.0153651,
    -0.029747, 0.0528968, 0.0155452, -0.0604701, 0.00774953, -0.0673761,
    0.0450282, 0.00403405, -0.056351, -0.0747967, -0.00317429, 0.00762683,
    0.0684082, -0.0129142, -0.123977, 0.105213, -0.0881814, -0.0121003,
    0.0314497, 0.0708361, -0.0798091, 0.0637551
]);
exports.serifBold = convert([
    -0.0323803, -0.00102793, 0.0124376, 0.0971664, -0.0357509, 0.00880437,
    0.0196418, 0.0928425, 0.0264077, 0.0598407, 0.0200502, 0.00457189,
    0.00607683, -0.0226146, -0.0818296, 0.076762, 0.0432937, 0.00609478,
    -0.0218808, 0.0843609, 0.040894, 0.0583095, -0.00730641, -0.00898112,
    0.0336852, -0.0283388, 0.144419, 0.000946873, -0.030562, 0.0232463,
    -0.0181779, -0.0490096, 0.0204086, 0.0238225, -0.0453906, -0.0710924,
    0.00432009, 0.0292283, -0.106795, -0.00453245
]);
exports.serifBoldItalic = convert([
    -0.0054048, 0.0159092, 0.0302168, 0.0697037, -0.0204759, 0.000776367,
    0.0702093, 0.121289, 0.0412071, 0.053307, 0.0288946, -0.0800687,
    -0.00795932, -0.0132502, -0.0818488, 0.0581822, 0.0970594, -0.012045,
    -0.029754, 0.0763988, 0.0766911, 0.000334531, -0.00143468, 0.0227631,
    0.0177566, -0.00738354, 0.139812, 0.000561706, -0.00535678, -0.0189456,
    -0.0309518, -0.067577, 0.0270824, 0.0201032, -0.00600616, -0.0466973,
    -0.0193195, 0.0180092, -0.077959, -0.0681573
]);
exports.serifBlack = convert([
    0.0909758, 0.00873388, -0.0452807, 0.00794899, -0.10172, 0.0133421,
    0.0696997, 0.0798673, -0.00728477, 0.0671067, 0.0967286, -0.00251602,
    -0.0127565, 0.033712, -0.0199663, 0.127594, 0.122419, -0.0489552,
    -0.0650608, 0.114194, 0.0634069, 0.0545759, 0.101358, -0.0545972,
    -0.0751137, -0.0346449, -0.000180635, -0.0436914, -0.081506, -0.0354884,
    0.179283, -0.0188949, -0.150555, 0.08059, -0.17566, -0.0940503,
    -0.0355069, 0.0737371, -0.0923994, -0.00678041
]);
exports.serifBlackItalic = convert([
    0.0530746, 0.0259746, -0.0597457, -0.0136301, -0.093447, -0.0184798,
    0.0865628, 0.0964154, -0.0393477, 0.0705582, 0.110879, -0.022009,
    -0.00691234, 0.0219029, -0.0324838, 0.140535, 0.125854, -0.0149923,
    -0.074845, 0.11951, 0.068344, 0.0206063, 0.104076, -0.0651419,
    -0.0850527, -0.0183039, -0.0378232, -0.0587197, -0.0510641, -0.056276,
    0.15372, -0.0440933, -0.116309, 0.0375091, -0.144264, -0.103141,
    -0.0321945, 0.0593374, -0.0764209, -0.0303033
]);
exports.sans = convert([
    0.0329864, 0.0278972, -0.0212594, -0.0438054, -0.20673, -0.0515144,
    0.0639917, 0.0071013, 0.0178006, 0.0202469, 0.0394936, -0.064725,
    0.00262303, 0.0336765, -0.0756649, 0.143307, 0.0699408, -0.016698,
    -0.0000120884, 0.0745099, -0.0289819, 0.0914947, 0.0431428, -0.0554285,
    0.0503002, -0.0245987, -0.0348133, 0.0529588, -0.038719, 0.0323447,
    0.0779103, -0.0476502, -0.098699, 0.128599, -0.107683, 0.051812,
    -0.0101372, 0.0735326, 0.0152828, 0.0746854
]);
exports.sansLight = convert([
    -0.0912144, -0.11, 0.111232, 0.0268911, -0.184624, -0.139461,
    0.00970334, -0.137672, 0.0603388, -0.136661, -0.0319242, -0.139704,
    -0.0818626, 0.049725, -0.0953409, 0.0501449, 0.00715698, -0.127478,
    0.0386167, 0.00127029, -0.0356171, 0.00945161, 0.0668662, 0.0346777,
    0.117317, -0.122311, 0.0307563, 0.114127, -0.0105379, 0.116233,
    -0.121305, 0.0644086, -0.0347309, 0.0577119, -0.00765444, 0.0328864,
    0.143528, 0.00445927, -0.0237287, 0.030197
]);
exports.arched = convert([
    0.0806872, 0.110965, 0.086886, -0.00180176, -0.0882071, 0.0779456,
    0.0905633, 0.00644794, 0.0859038, -0.0775584, 0.0663978, 0.0141178,
    0.0838117, -0.0447576, -0.0403048, 0.159673, 0.0229668, 0.0858101,
    0.00908829, -0.0140885, -0.176689, -0.0666698, -0.00964185, -0.0151287,
    -0.0113516, -0.0881685, -0.0283303, 0.191189, -0.00184261, 0.130461,
    -0.00693196, 0.069367, 0.138793, -0.0119836, -0.00572119, 0.0451849,
    -0.0238382, 0.0167064, -0.0301301, 0.0886809
]);
exports.square = convert([
    -0.0446289, -0.0149773, -0.0385331, -0.0707373, -0.0335624, -0.201168,
    0.120355, -0.118127, 0.0193889, -0.191945, -0.0340819, -0.130116,
    -0.0197822, -0.0997182, -0.0679762, 0.160299, 0.103083, -0.110458,
    0.188874, -0.00039908, -0.0740328, 0.085555, -0.109459, -0.0214472,
    -0.135185, -0.0415408, 0.162826, 0.325578, -0.122402, 0.102094,
    -0.250864, 0.146409, 0.282807, -0.102158, -0.00259758, 0.0411024,
    0.111681, 0.0713722, -0.0335932, 0.157342
]);
exports.dotMatrix = convert([
    0.060615, -0.000465715, 0.0246598, 0.0944611, 0.0666274, -0.0487324,
    0.0286003, -0.184103, -0.00240539, -0.058848, 0.0184425, 0.0947951,
    0.046714, -0.153271, 0.00900223, 0.0192062, -0.0691753, 0.0742756,
    -0.0274342, -0.104143, -0.0353343, -0.106598, 0.0335441, -0.0642195,
    0.203262, -0.0234517, -0.0228208, 0.0302247, -0.185438, 0.039308,
    0.0761878, -0.0673214, 0.143452, -0.0856933, 0.0308359, 0.0629813,
    -0.0623102, -0.0449193, 0.0364476, 0.0169692
]);
exports.casual = convert([
    0.0375602, -0.0491304, -0.0209641, -0.103011, 0.0308724, -0.130895,
    0.0821889, -0.0146466, -0.0728875, 0.0734076, 0.01331, -0.0789973,
    -0.00970982, -0.0468304, 0.0635698, 0.152492, -0.00944289, 0.0296184,
    0.0047967, -0.0385626, 0.172074, -0.0191523, 0.0310322, -0.00679372,
    -0.0823408, 0.0634969, -0.0291813, -0.059585, -0.0135221, 0.0263487,
    0.0286055, -0.0484182, -0.00803214, 0.0575465, 0.139084, 0.0246161,
    -0.156613, 0.0779903, 0.139666, -0.0533868
]);
exports.crispSerif = convert([
    -0.0117122, 0.0198984, 0.0271978, 0.0189575, -0.0547227, -0.0196669,
    0.0841931, 0.0295952, 0.105422, -0.0219258, -0.0683342, -0.132337,
    0.02767, 0.126789, -0.0759635, 0.121098, 0.0405861, 0.00972959,
    -0.011304, -0.0166254, -0.0443834, 0.0307285, -0.057004, -0.0877993,
    0.00314376, 0.0302306, -0.0127057, -0.0242177, -0.00113233, -0.0242625,
    0.133443, 0.110555, -0.126315, 0.087721, -0.0995809, -0.0480722,
    0.155882, 0.0690852, -0.0772831, 0.0284894
]);


/***/ }),

/***/ 328:
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27b6baf7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FontChooser.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.samples),function(sample,index){return _c('div',{staticClass:"typeface"},[_vm._l((_vm.letters),function(char){return _c('div',{staticClass:"character",on:{"click":function($event){_vm.select(sample)}}},[_c('Sample',{attrs:{"displayWidth":_vm.width,"displayHeight":_vm.width,"model":_vm.model,"modelData":char,"sample":sample,"visible":_vm.visible}})],1)}),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.deleteSample(index)}}},[_vm._v("✕")]),_vm._v(" "),_c('span',{staticClass:"ellipse"},[_vm._v("…")])],2)}),_vm._v(" "),_c('button',{on:{"click":_vm.save}},[_vm._v("Save current sample")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 329:
/*!*********************************!*\
  !*** ./components/Alphabet.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Alphabet_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Alphabet.vue */ 142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a3ed29c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alphabet_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6a3ed29c","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Alphabet.vue */ 331);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6a3ed29c","scoped":true,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Alphabet.vue */ 330)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a3ed29c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Alphabet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a3ed29c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alphabet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 330:
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a3ed29c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Alphabet.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 331:
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a3ed29c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Alphabet.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sections),function(section){return _c('div',{staticClass:"section"},_vm._l((section),function(char){return _c('div',{key:char,staticClass:"character"},[_c('Sample',{attrs:{"displayWidth":_vm.width,"displayHeight":_vm.width,"model":_vm.model,"modelData":char,"sample":_vm.sample,"visible":_vm.visible,"on:select":"fire('select', event)"}})],1)}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 332:
/*!****************************!*\
  !*** ./utils/FontModel.ts ***!
  \****************************/
/*! dynamic exports provided */
/*! exports used: FontModel */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dl = __webpack_require__(/*! deeplearn */ 32);
var ModelCache_1 = __webpack_require__(/*! ./ModelCache */ 333);
var NUM_LAYERS = 4;
var IMAGE_SIZE = 64;
var FontModel = (function () {
    function FontModel() {
        this.metaData = 'A';
        this.dimensions = 40;
        this.range = 0.4;
        this.inferCache = new ModelCache_1.Cache(this, this.infer);
        this.numberOfValidChars = 62;
        this.multiplierScalar = dl.scalar(255);
        this.charIdMap = {};
        for (var i = 65; i < 91; i++) {
            this.charIdMap[String.fromCharCode(i)] = i - 65;
        }
        for (var i = 97; i < 123; i++) {
            this.charIdMap[String.fromCharCode(i)] = i - 97 + 26;
        }
        for (var i = 48; i < 58; i++) {
            this.charIdMap[String.fromCharCode(i)] = i - 48 + 52;
        }
    }
    FontModel.prototype.load = function (cb) {
        var _this = this;
        var checkpointLoader = new dl.CheckpointLoader('https://storage.googleapis.com/learnjs-data/checkpoint_zoo/fonts/');
        checkpointLoader.getAllVariables().then(function (vars) {
            _this.variables = vars;
            cb();
        });
    };
    FontModel.prototype.get = function (id, args, priority) {
        var _this = this;
        args.push(this.metaData);
        return new Promise(function (resolve, reject) {
            args.push(function () { return resolve(); });
            _this.inferCache.get(id, args);
        });
    };
    FontModel.prototype.infer = function (args) {
        var _this = this;
        var embedding = args[0];
        var ctx = args[1];
        var char = args[2];
        var cb = args[3];
        var charId = this.charIdMap[char.charAt(0)];
        if (charId == null) {
            throw (new Error('Invalid character id'));
        }
        var adjusted = dl.tidy(function () {
            var idx = dl.tensor1d([charId]);
            var onehotVector = dl.oneHot(idx, _this.numberOfValidChars).as1D();
            var axis = 0;
            var inputData = embedding.as1D().concat(onehotVector, axis);
            var lastOutput = inputData;
            for (var i = 0; i < NUM_LAYERS; i++) {
                var weights = _this.variables["Stack/fully_connected_" + (i + 1) + "/weights"];
                var biases = _this.variables["Stack/fully_connected_" + (i + 1) + "/biases"];
                lastOutput = lastOutput.as2D(-1, weights.shape[0])
                    .matMul(weights)
                    .add(biases)
                    .relu();
            }
            var finalWeights = _this.variables['fully_connected/weights'];
            var finalBiases = _this.variables['fully_connected/biases'];
            var finalOutput = lastOutput.as2D(-1, finalWeights.shape[0])
                .matMul(finalWeights)
                .add(finalBiases)
                .sigmoid();
            return _this.multiplierScalar.sub(_this.multiplierScalar.mul(finalOutput));
        });
        var d = adjusted.as3D(IMAGE_SIZE, IMAGE_SIZE, 1);
        d.data().then(function (values) {
            var imageData = ctx.createImageData(IMAGE_SIZE, IMAGE_SIZE);
            var pixelOffset = 0;
            for (var i = 0; i < values.length; i++) {
                var value = values[i];
                imageData.data[pixelOffset++] = value;
                imageData.data[pixelOffset++] = value;
                imageData.data[pixelOffset++] = value;
                imageData.data[pixelOffset++] = 255;
            }
            ctx.putImageData(imageData, 0, 0);
            d.dispose();
            cb();
        });
    };
    return FontModel;
}());
exports.FontModel = FontModel;


/***/ }),

/***/ 333:
/*!*****************************!*\
  !*** ./utils/ModelCache.ts ***!
  \*****************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ChunkedQueue_1 = __webpack_require__(/*! ./ChunkedQueue */ 334);
var Cache = (function () {
    function Cache(thisArg, fn) {
        this.queue = new ChunkedQueue_1.Queue();
        this._paused = false;
        this.thisArg = thisArg;
        this.fn = fn;
        this.queue.interval = 10;
        this.queue.elementsPerChunk = 20;
    }
    Cache.prototype.get = function (id, argsArray) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var value = _this.fn.call(_this.thisArg, argsArray);
            _this.queue.add(function () {
                _this.fn.call(_this.thisArg, argsArray);
                resolve(value);
            }, id, 0);
        });
    };
    Object.defineProperty(Cache.prototype, "paused", {
        get: function () {
            return this._paused;
        },
        set: function (p) {
            this._paused = p;
        },
        enumerable: true,
        configurable: true
    });
    return Cache;
}());
exports.Cache = Cache;


/***/ }),

/***/ 334:
/*!*******************************!*\
  !*** ./utils/ChunkedQueue.ts ***!
  \*******************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Queue = (function () {
    function Queue() {
        this.interval = 1000;
        this.elementsPerChunk = 1;
        this.timeoutID = -1;
        this.clear();
    }
    Queue.prototype.add = function (cb, id, priority) {
        this.remove(id);
        if (id == null) {
            id = -1;
        }
        if (priority == null) {
            priority = -1;
        }
        this.queue.push({ cb: cb, id: id, priority: priority });
        this.queue.sort(function (a, b) { return a.priority - b.priority; });
        this.kick();
    };
    Queue.prototype.clear = function () {
        clearTimeout(this.timeoutID);
        this.queue = [];
        this.running = false;
    };
    Object.defineProperty(Queue.prototype, "length", {
        get: function () {
            return this.queue.length;
        },
        enumerable: true,
        configurable: true
    });
    Queue.prototype.remove = function (id) {
        this.queue = this.queue.filter(function (item) { return id !== item.id; });
    };
    Queue.prototype.nextChunk = function () {
        return this.queue.splice(-this.elementsPerChunk);
    };
    Queue.prototype.kick = function () {
        var _this = this;
        if (!this.running) {
            this.running = true;
            this.timeoutID = window.setTimeout(function () { return _this.run(); }, this.interval);
        }
    };
    Queue.prototype.run = function () {
        var chunk = this.nextChunk();
        chunk.forEach(function (item) {
            item.cb();
        });
        this.running = false;
        if (this.queue.length) {
            this.kick();
        }
    };
    return Queue;
}());
exports.Queue = Queue;


/***/ }),

/***/ 335:
/*!*****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-545c3eb6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./App.vue ***!
  \*****************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('demo-header',{attrs:{"name":"Latent Space Explorer"}}),_vm._v(" "),_c('div',{staticClass:"app"},[_c('div',{staticClass:"presets"},[_c('div',{staticClass:"header sticky"},[_c('h3',[_vm._v("Saved Samples")]),_vm._v(" "),_c('FontChooser',{attrs:{"model":_vm.model,"selectedSample":_vm.selectedSample},on:{"select":_vm.changeSelected}}),_vm._v(" "),_vm._m(0)],1)]),_vm._v(" "),_c('div',{staticClass:"input"},[_vm._m(1),_vm._v(" "),_c('div',{ref:"loading"},[_vm._v("Loading...")]),_vm._v(" "),_c('div',{ref:"basis",staticClass:"basis"},[_c('BasisDimensions',{attrs:{"scrollY":_vm.scrollY,"model":_vm.model,"modelData":_vm.modelData,"numSamples":_vm.numSamples,"selectedSample":_vm.selectedSample,"range":_vm.range,"vals":_vm.dimSliderVals,"width":_vm.width},on:{"select":_vm.changeSelected}})],1)]),_vm._v(" "),_c('div',{staticClass:"output"},[_c('div',{staticClass:"header sticky"},[_c('h3',[_vm._v("Current Sample")]),_vm._v(" "),_c('Alphabet',{attrs:{"model":_vm.model,"sample":_vm.selectedSample}})],1)])]),_vm._v(" "),_c('demo-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description"},[_vm._v("This demo allows you to interactively explore\n           a 40-dimensional latent space of typefaces. The model used here\n           was created by "),_c('a',{attrs:{"href":"https://twitter.com/bengiswex"}},[_vm._v("James Wexler")]),_vm._v(",\n           based on work by\n           "),_c('a',{attrs:{"href":"https://erikbern.com/2016/01/21/analyzing-50k-fonts-using-deep-neural-networks.html"}},[_vm._v("Erik Bernhardsson")]),_vm._v(",\n           and is used in the distill.pub article\n           "),_c('a',{attrs:{"href":"https://distill.pub/2017/aia/"}},[_vm._v("Using Artificial Intelligence to Augment Human Intelligence\"")]),_vm._v(",\n           which describes the model in greater detail.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h3',[_vm._v("Basis Dimensions of the Latent Space")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 37:
/*!*******************************!*\
  !*** ./components/Sample.vue ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Sample_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Sample.vue */ 70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a91f88f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sample_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3a91f88f","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Sample.vue */ 159);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3a91f88f","scoped":true,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Sample.vue */ 158)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a91f88f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_usr_local_google_home_jwexler_pair_code_font_explorer_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Sample_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a91f88f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sample_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 67:
/*!***********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./App.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer_vue__ = __webpack_require__(/*! ./components/footer.vue */ 150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header_vue__ = __webpack_require__(/*! ./components/header.vue */ 153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BasisDimensions_vue__ = __webpack_require__(/*! ./components/BasisDimensions.vue */ 156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FontChooser_vue__ = __webpack_require__(/*! ./components/FontChooser.vue */ 325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Alphabet_vue__ = __webpack_require__(/*! ./components/Alphabet.vue */ 329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_FontModel__ = __webpack_require__(/*! ./utils/FontModel */ 332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_FontModel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utils_FontModel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_deeplearn__ = __webpack_require__(/*! deeplearn */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_deeplearn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_deeplearn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Alphabet: __WEBPACK_IMPORTED_MODULE_5__components_Alphabet_vue__["a" /* default */],
    BasisDimensions: __WEBPACK_IMPORTED_MODULE_3__components_BasisDimensions_vue__["a" /* default */],
    DemoFooter: __WEBPACK_IMPORTED_MODULE_1__components_footer_vue__["default"],
    DemoHeader: __WEBPACK_IMPORTED_MODULE_2__components_header_vue__["a" /* default */],
    FontChooser: __WEBPACK_IMPORTED_MODULE_4__components_FontChooser_vue__["a" /* default */]
  },
  data: function data() {
    return {
      model: undefined,
      modelData: "A",
      numSamples: 9,
      range: 0.4,
      width: 400,
      dimSliderVals: [],
      selectedSample: undefined,
      scrollY: 0
    };
  },

  mounted: function mounted() {
    var _this = this;

    window.addEventListener("resize", this.onresize);
    window.addEventListener("scroll", this.onscroll);

    var fonts = new __WEBPACK_IMPORTED_MODULE_6__utils_FontModel__["FontModel"]();
    fonts.load(function () {
      _this.$refs.loading.remove();
      _this.model = fonts;
      _this.range = fonts.range;
      _this.resize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onresize);
    window.removeEventListener("scroll", this.onscroll);
  },
  methods: {
    resize: function resize() {
      var width = this.$refs.basis.getBoundingClientRect().width;
      this.width = width;
      this.onscroll();
    },
    onscroll: function onscroll() {
      var y = window.scrollY;
      this.scrollY = Math.round(y / 20) * 20;
    },
    changeSelected: function changeSelected(event) {
      // If this is the initial (default) selection and a URL hash was
      // provided then use the sample from the hash.

      if (event.isInitialSelection && window.location.hash) {
        this.parseUrlHash();
      } else {
        this.selectedSample = event.selectedSample;
        this.updateHash();
      }
    },
    updateHash: function updateHash() {
      if (this.selectedSample) {
        this.selectedSample.data().then(function (vals) {
          var hashStr = '#' + Array.from(vals).map(function (val) {
            return parseFloat(val).toFixed(3);
          }).join(',');
          history.replaceState(undefined, undefined, hashStr);
        });
      }
    },
    parseUrlHash: function parseUrlHash() {
      var hash = window.location.hash;
      var dimVals = hash.substring(1).split(',').map(function (val) {
        return +val;
      });
      // Set the selected sample and initial dimension slider values based
      // on the provided URL hash.
      this.dimSliderVals = dimVals;
      this.selectedSample = __WEBPACK_IMPORTED_MODULE_7_deeplearn__["tensor1d"](dimVals);
    }
  }

});

/***/ }),

/***/ 68:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/footer.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

(function (i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
    (i[r].q = i[r].q || []).push(arguments);
  }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

ga('create', 'UA-46457317-8', 'auto');
ga('send', 'pageview');

/***/ }),

/***/ 69:
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/BasisDimensions.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sample_vue__ = __webpack_require__(/*! ./Sample.vue */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tray_vue__ = __webpack_require__(/*! ./Tray.vue */ 160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_array__ = __webpack_require__(/*! d3-array */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_deeplearn__ = __webpack_require__(/*! deeplearn */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_deeplearn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_deeplearn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var math = __WEBPACK_IMPORTED_MODULE_3_deeplearn__["ENV"].math;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Sample: __WEBPACK_IMPORTED_MODULE_0__Sample_vue__["a" /* default */], Tray: __WEBPACK_IMPORTED_MODULE_1__Tray_vue__["a" /* default */] },
  data: function data() {
    return {
      basisDimensions: []
    };
  },

  watch: {
    model: function model(m) {
      var dims = m ? m.dimensions : 0;
      this.basisDimensions = Object(__WEBPACK_IMPORTED_MODULE_2_d3_array__["e" /* range */])(dims).map(function (dim) {
        return math.oneHot(__WEBPACK_IMPORTED_MODULE_3_deeplearn__["tensor1d"]([dim]), dims).as1D();
      });
    }
  },
  props: {
    modelData: { type: String, default: "A" },
    selectedSample: { default: function _default() {
        [];
      } },
    model: {},
    width: { type: Number, default: 300 },
    numSamples: { type: Number, default: 5 },
    range: { type: Number, default: 1 },
    vals: { type: Array, default: function _default() {
        return [];
      } },
    scrollY: { default: 0 }
  },
  methods: {
    select: function select(event) {
      this.$emit("select", event);
    }
  }
});

/***/ }),

/***/ 70:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Sample.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      width: 64,
      height: 64,
      waiting: false,
      dirty: false,
      priority: 0,
      position: 0,
      id: Math.random()
    };
  },

  props: {
    modelData: { type: String, default: "A" },
    displayWidth: { type: Number, default: "64" },
    displayHeight: { type: Number, default: "64" },
    sample: { default: function _default() {
        [];
      } },
    model: {},
    visible: { default: false }
  },
  mounted: function mounted() {
    this.render();
  },
  watch: {
    visible: function visible(val) {
      if (this.model && this.sample) {
        if (this.dirty && val) {
          this.render();
        }
      }
    },
    sample: function sample(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        if (this.visible) {
          this.render();
        } else {
          this.dirty = true;
        }
      }
    },
    model: function model(val) {
      this.render();
    }
  },
  methods: {
    measure: function measure() {
      var bb = this.$refs.canvas.getBoundingClientRect();
      var screen = window.innerHeight;
      this.position = bb.top;
      this.visible = bb.top < window.innerHeight && bb.bottom > 0;
    },
    render: function render() {
      var _this = this;

      this.waiting = true;
      if (this.model) {
        this.model.metaData = this.modelData;
      }
      if (this.model && this.sample && this.sample.size) {
        var canvas = this.$refs.canvas;
        var canvasContext = canvas.getContext("2d");
        this.model.get(this.id, [this.sample, canvasContext]).then(function () {
          _this.waiting = false;
          _this.dirty = false;
        });
      }
    }
  }
});

/***/ }),

/***/ 71:
/*!***********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Tray.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sample_vue__ = __webpack_require__(/*! ./Sample.vue */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__XAxis_vue__ = __webpack_require__(/*! ./XAxis.vue */ 162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_array__ = __webpack_require__(/*! d3-array */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_format__ = __webpack_require__(/*! d3-format */ 53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_scale__ = __webpack_require__(/*! d3-scale */ 73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deeplearn__ = __webpack_require__(/*! deeplearn */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deeplearn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_deeplearn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var math = __WEBPACK_IMPORTED_MODULE_5_deeplearn__["ENV"].math;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Sample: __WEBPACK_IMPORTED_MODULE_0__Sample_vue__["a" /* default */], Axis: __WEBPACK_IMPORTED_MODULE_1__XAxis_vue__["a" /* default */] },
  data: function data() {
    return {
      interpolate: Object(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["b" /* scaleLinear */])(),
      position: Object(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["b" /* scaleLinear */])(),
      bandScale: Object(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["a" /* scaleBand */])(),
      formatter: Object(__WEBPACK_IMPORTED_MODULE_3_d3_format__["a" /* format */])(",.3f"),
      visible: false,
      samples: [],
      offset: 0,
      selectedX: 0,
      selectedValue: 0
    };
  },

  props: {
    modelData: { type: String, default: "A" },
    model: {},
    numSamples: { type: Number, default: 9 },
    width: { type: Number, default: 200 },
    initialValue: { type: Number, default: 1 },
    selectedSample: null,
    direction: null,
    range: { type: Number, default: 1 },
    scrollY: { default: 0 }
  },
  computed: {
    extent: function extent() {
      return [-this.range, this.range];
    },
    hoverScale: function hoverScale() {
      return this.interpolate.domain([0, this.width]).range(this.extent).clamp(true);
    },
    bands: function bands() {
      return this.bandScale.domain(Object(__WEBPACK_IMPORTED_MODULE_2_d3_array__["e" /* range */])(this.numSamples)).range([0, this.width]);
    },
    pos: function pos() {
      return this.position.domain([0, this.numSamples - 1]).range(this.extent);
    },
    sampleWidth: function sampleWidth() {
      return this.bands.bandwidth();
    },
    height: function height() {
      return this.sampleWidth;
    }

  },
  mounted: function mounted() {
    this.computeDirection();
    this.recomputeSamples();
    this.checkVisibility();
  },

  watch: {
    selectedSample: function selectedSample() {
      this.computeDirection();
    },
    model: function model() {
      this.recomputeSamples();
    },
    width: function width() {
      this.recomputeSamples();
    },
    scrollY: function scrollY(val) {
      this.checkVisibility();
    },
    direction: function direction() {
      this.computeDirection();
    }
  },
  methods: {
    computeDirection: function computeDirection() {
      var _this = this;

      var length = math.sum(math.multiply(this.direction, this.direction));
      this.unitDirection = math.divide(this.direction, length);
      var scalar = math.dotProduct(this.unitDirection, this.selectedSample);
      scalar.data().then(function (values) {
        _this.selectedValue = values[0];
        _this.selectedX = _this.hoverScale.invert(_this.selectedValue);
        _this.recomputeSamples();
      });
    },

    dragStart: function dragStart(event) {
      document.addEventListener("mousemove", this.dragUpdate);
      document.addEventListener("mouseup", this.dragEnd);
      this.offset = this.$refs.container.getBoundingClientRect().left;
    },
    dragUpdate: function dragUpdate(event) {
      event.preventDefault();
      this.select(event.pageX - this.offset);
    },
    dragEnd: function dragEnd(event) {
      this.select(event.pageX - this.offset);
      document.removeEventListener("mouseup", this.dragEnd);
      document.removeEventListener("mousemove", this.dragUpdate);
    },
    recomputeSamples: function recomputeSamples() {
      var samples = [];
      for (var i = 0; i < this.numSamples; i++) {
        var delta = math.sub(__WEBPACK_IMPORTED_MODULE_5_deeplearn__["scalar"](this.pos(i)), __WEBPACK_IMPORTED_MODULE_5_deeplearn__["scalar"](this.selectedValue));
        var newSample = math.add(math.multiply(this.unitDirection, delta), this.selectedSample);
        samples.push({
          sample: newSample,
          position: this.bands(samples.length)
        });
      }
      this.samples = samples;
    },
    checkVisibility: function checkVisibility() {
      var buffer = 200;
      var top = this.$refs.container.getBoundingClientRect().top;
      var visible = top > -buffer && top < window.innerHeight + buffer;
      this.visible = visible;
    },
    format: function format(val) {
      return this.formatter(val);
    },
    select: function select(x) {
      var value = this.hoverScale(x);
      var delta = math.sub(__WEBPACK_IMPORTED_MODULE_5_deeplearn__["scalar"](value), __WEBPACK_IMPORTED_MODULE_5_deeplearn__["scalar"](this.selectedValue));
      var newSample = math.add(math.multiply(this.unitDirection, delta), this.selectedSample);
      this.$emit("select", { selectedSample: newSample });
    }
  }
});

/***/ }),

/***/ 72:
/*!************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/usr/local/google/home/jwexler/pair-code/font-explorer/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/XAxis.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_scale__ = __webpack_require__(/*! d3-scale */ 73);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      scale: Object(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["b" /* scaleLinear */])()
    };
  },

  props: {
    min: { default: 0 },
    max: { default: 1 },
    width: { default: 1 }
  },
  computed: {
    xScale: function xScale() {
      return this.scale.domain([this.min, this.max]).range([0, this.width]);
    },
    ticks: function ticks() {
      var _this = this;

      return this.xScale.ticks().map(function (t) {
        return { value: t, position: _this.xScale(t) };
      });
    }
  }
});

/***/ })

},[143]);


// WEBPACK FOOTER //
// client.25a149c9.js